/* Research Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';

export interface ISearchFiltersResearchBidsState {
    associationTypeIdsMulti: any;
    buildingsHigh: any;
    buildingsLow: any;
    clientIdsMulti: any;
    contact: string;
    dateRange: string;
    fromBidDate: string;
    toBidDate: string;
    fromCompletionDate: string;
    toCompletionDate: string;
    poolsMulti: any;
    regionIdsMulti: any;
    streetsMulti: any;
    unitsHigh: any;
    unitsLow: any;
    statusIdsMulti?: any;
    spasMulti?: any;
}

// const defaultDateRangeValue = DateRanges.DateRangeOptionValues.LAST_THREE_YEARS;
const defaultDateRangeValue = DateRanges.DateRangeOptionValues.TOMORROW;
const defaultSearchIdValue: number = -1;
const defaultSearchTextValue: string = '';

const initialState: ISearchFiltersResearchBidsState = {
    associationTypeIdsMulti: DateRanges.getArray(defaultSearchIdValue),
    buildingsHigh: 5000,
    buildingsLow: 0,
    clientIdsMulti: DateRanges.getArray(defaultSearchIdValue),
    contact: '',
    dateRange: defaultDateRangeValue,
    fromBidDate: DateRanges.getStartDate(defaultDateRangeValue),
    toBidDate: DateRanges.getEndDate(defaultDateRangeValue),
    fromCompletionDate: '',
    toCompletionDate: '',
    poolsMulti: DateRanges.getArray(defaultSearchIdValue),
    regionIdsMulti: DateRanges.getArray(defaultSearchIdValue),
    statusIdsMulti: DateRanges.getArray(defaultSearchIdValue),
    spasMulti: DateRanges.getArray(defaultSearchIdValue),
    streetsMulti: DateRanges.getArray(defaultSearchTextValue),
    unitsHigh: 25000,
    unitsLow: 0,
};

export function searchFiltersResearchBidsReducer(state: ISearchFiltersResearchBidsState = initialState, action: any): ISearchFiltersResearchBidsState {
    switch (action.type) {
        case Actions.SEARCH_RESEARCH_BIDS_ALL:
            return _.merge({}, state, action.state);
        case Actions.SEARCH_RESEARCH_BIDS_UNITS_RANGE:
            return _.merge({}, state, { unitsLow: action.low, unitsHigh: action.high });
        case Actions.SEARCH_RESEARCH_BIDS_BUILDINGS_RANGE:
            return _.merge({}, state, { buildingsLow: action.low, buildingsHigh: action.high });

        case Actions.SEARCH_RESEARCH_BIDS_FROM_BID_DATE:
            return _.merge({}, state, { fromBidDate: action.value });
        case Actions.SEARCH_RESEARCH_BIDS_TO_BID_DATE:
            return _.merge({}, state, { toBidDate: action.value });
        case Actions.SEARCH_RESEARCH_BIDS_DATE_RANGE:
            return _.merge({}, state, {
                dateRange: action.dateRange,
                fromBidDate: DateRanges.getStartDate(action.dateRange),
                toBidDate: DateRanges.getEndDate(action.dateRange),
            });
        case Actions.SEARCH_RESEARCH_BIDS_FROM_COMPLETION_DATE:
            return _.merge({}, state, { fromCompletionDate: action.value });
        case Actions.SEARCH_RESEARCH_BIDS_TO_COMPLETION_DATE:
            return _.merge({}, state, { toCompletionDate: action.value });

        case Actions.SEARCH_RESEARCH_BIDS_STATUSES_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { statusIdsMulti: newValue });

            internalResult.statusIdsMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_SPAS_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { spasMulti: newValue });

            internalResult.spasMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_POOLS_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { poolsMulti: newValue });

            internalResult.poolsMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_STREETS_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { streetsMulti: newValue });

            internalResult.streetsMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_ASSOCIATION_TYPES_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { associationTypeIdsMulti: newValue });

            internalResult.associationTypeIdsMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_CLIENTS_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { clientIdsMulti: newValue });

            internalResult.clientIdsMulti = newValue;

            return internalResult;
        }
        case Actions.SEARCH_RESEARCH_BIDS_REGIONS_MULTI: {
            const newValue = _.cloneDeep(action.value);
            let internalResult = _.merge({}, state, { regionIdsMulti: newValue });

            internalResult.regionIdsMulti = newValue;

            return internalResult;
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersResearchBidsReducer.tsx